import {Component, inject, Input, OnDestroy, OnInit, signal, ViewChild} from '@angular/core';
import {FormsModule, NgForm} from "@angular/forms";
import {AsyncPipe, NgIf} from "@angular/common";
import {Router, RouterOutlet} from "@angular/router";
import {FeatherModule} from "angular-feather";
import {SharedCommonModule} from "../../../../../shared/commons/shared-common.module";
import {AgePipe} from "../../../../../shared/age.pipe";
import {RegisterFormsComponent} from "../../../register/register-forms/register-forms.component";
import {RightDetailComponent} from "../../right-detail/right-detail.component";
import {NotFoundComponent} from "../../../../../shared/not-found/not-found.component";
import {AsyncLoadingComponent} from "../../../../../shared/async-loading/async-loading.component";
import {AsyncErrorComponent} from "../../../../../shared/async-error/async-error.component";
import {CustomErrorComponent} from "../../../../../shared/commons/custom-error.component";
import {RightSearchResource} from "../../../../../service/RightSearchResource";
import {RightSearchResult, Source} from "../../../../../../generated-model/model";

@Component({
  selector: 'app-right-search-by-pid',
  standalone: true,
  imports: [
    FormsModule,
    AsyncPipe,
    NgIf,
    SharedCommonModule,
    AgePipe,
    RouterOutlet,
    RegisterFormsComponent,
    RightDetailComponent,
    FeatherModule,
    NotFoundComponent,
    AsyncLoadingComponent,
    AsyncErrorComponent,
    CustomErrorComponent
  ],
  templateUrl: './right-search-by-name-detail.component.html',
  styleUrl: './right-search-by-name-detail.component.scss'
})
export class RightSearchByNameDetailComponent implements OnInit, OnDestroy {

  @ViewChild("form", {read: NgForm, static: true}) form: NgForm;
  @Input("personalId") personalId!: string;
  @Input("firstName") firstName!: string;
  @Input("lastName") lastName!: string;
  @Input("source") source!: Source;
  checkRightsResource = inject(RightSearchResource);
  router = inject(Router);
  data = signal(undefined as RightSearchResult);
  isLoading = false;

  constructor() {
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.checkRightsResource.findByPersonalIdAndName(this.personalId, this.firstName, this.lastName, this.source)
      .subscribe({
        next: e => {
          this.data.set(e);
        }, error: error => {
          this.isLoading = false;
        }, complete: () => {
          this.isLoading = false;
        }
      });
  }

  ngOnDestroy(): void {
  }
}
